<template>
  <div class="app-options-success">
    <div :class="'left-space '" v-if="!isService">
      <div class="option-image">
        <img :src="option.option.image" alt="Option">
      </div>
    </div>
    <div class="right-space">
      <p class="headline" v-html="option.option.name"></p>
      <div class="content">
        <dyn-slot :slot-data="slotData">
          <slot v-if="option.type === 'book' && !isService" name="txtContentBook"></slot>
          <slot v-if="option.type === 'book' && isService"  name="txtContentBookService"></slot>
          <slot v-if="option.type === 'cancel' && !isService" name="txtContentCancel"></slot>
          <slot v-if="option.type === 'cancel' && isService" name="txtContentCancelService"></slot>
        </dyn-slot>
      </div>
      <div >
        <Stepper :showNext="false" @prev="prev">
        </Stepper>
      </div>
    </div>
  </div>
</template>
<script>

import slotProxy from '@/mixins/slotProxy'
import Stepper from '../../../../generic/Stepper.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'Success',
  components: { Stepper },
  mixins: [
    slotProxy()
  ],
  computed: {
    slotData: function () {
      return this.option
    },
    isService: function () {
      return this.option.option?.type === 'service'
    }
  },
  methods: {
    ...mapMutations('bookTariffOptions', [
      'changeStep'
    ]),
    next () {
      this.$emit('next')
    },
    prev () {
      this.$emit('prev')
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
